import { Formik, Form } from 'formik'
import { Fragment, useState } from 'react'
import Column from '@components/column'
import FieldOverview from '@commons/cards/fieldOverview'
import { useSelector } from 'react-redux'
import Modal from '@components/modal'
import Button from '@components/button'
import { User } from '@apis'
import Row from '@components/row'
import { StyleTag } from './style'
import Svg from '@components/svg'
import ChooseSpecializations from '@commons/specializations'
const Specializations = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const [visible, setVisible] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(false)
  const submitHandler = async (values: any) => {
    setLoading(true)
    if (!!values?.specializations?.length) {
      await User.update({
        id: user?.id,

        data: {
          specializations: values?.specializations,
        },
      }).catch(() => {})
    }
    setLoading(false)
  }
  return (
    <Column>
      <FieldOverview
        title="Specialization"
        icon="edit"
        onClick={() => {
          setVisible(true)
        }}
      >
        {!!user?.specializations?.length ? (
          <Row colGap={10} rowGap={10} styleRow="flex-flow:row wrap">
            {user?.specializations?.map((specialization: any) => {
              return (
                <Fragment key={specialization?.id}>
                  <StyleTag>{specialization?.name}</StyleTag>
                </Fragment>
              )
            })}
          </Row>
        ) : (
          <Row>
            {Array(3)
              ?.fill(0)
              ?.map((_: any, index) => {
                return (
                  <Fragment key={index}>
                    <StyleTag>
                      <Svg svg="plusHeart" />
                      Add Specialization
                    </StyleTag>
                  </Fragment>
                )
              })}
          </Row>
        )}
      </FieldOverview>
      <Modal
        visible={visible}
        title="Add Specialization"
        onClose={() => {
          setVisible(false)
        }}
      >
        <Formik
          initialValues={{
            specializations: user?.specializations,
          }}
          onSubmit={submitHandler}
          enableReinitialize
        >
          {({ handleSubmit, setFieldValue, values, errors }: any) => {
            return (
              <Form onSubmit={handleSubmit}>
                <Column rowGap={20}>
                  <ChooseSpecializations
                    hasLabel={false}
                    isError={errors?.specializations}
                    selectedItems={values?.specializations}
                    onChange={(item: any) => {
                      const findIndex = values?.specializations?.findIndex(
                        (selected: any) => selected?.id == item.id,
                      )
                      if (findIndex >= 0) {
                        setFieldValue(
                          'specializations',
                          values?.specializations?.filter(
                            (symptom) => symptom?.id != item?.id,
                          ),
                        )
                      } else {
                        setFieldValue('specializations', [
                          ...values?.specializations,
                          item,
                        ])
                      }
                    }}
                  />
                  <Button
                    title="Submit"
                    loading={loading}
                    type="submit"
                    styleButton="width:100%"
                    height={40}
                  />
                </Column>
              </Form>
            )
          }}
        </Formik>
      </Modal>
    </Column>
  )
}

export default Specializations
